import request from '../utils/request'
const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/packmap'
// const baseUrl = ''
export function getMonitorInfo (parkFieldId) {
  return request({
    url: baseUrl + '/lcmonitorinfo/getLcMonitorInfoByparkfieldId',
    method: 'get',
    params: {
      parkFieldId: parkFieldId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/monitorInfo.js